module.exports = __webpack_public_path__ + "img/img_covertack_tiara.0702d716.png";